import { Buffer } from "buffer";
import process from "process";
import "core-js/actual";

if (typeof globalThis !== "undefined") {
  globalThis.Buffer = globalThis.Buffer || Buffer;
  globalThis.process = globalThis.process || process;
}
if (typeof window !== "undefined") {
  window.Buffer = window.Buffer || Buffer;
}
